import React, {PureComponent} from 'react';
// import ReactHtmlParser from 'react-html-parser';
import ReactQuill from 'react-quill';
import { inject, observer } from 'mobx-react';
import 'react-quill/dist/quill.snow.css';
import 'react-quill/dist/quill.bubble.css';

@inject('topicsStore')
@observer
class BaseInformation extends PureComponent {
  render() {
    const {topicsStore} = this.props;
    return (
      <div className="tab-container" style={{marginTop: '42px'}}>
        <div className="row">
          <div className="col-12 container-body">
            <ReactQuill
              name={ 'name' }
              value={ topicsStore.topic.description || '' }
              className={ `quill-toolbar-disabled` }
              readOnly={true}
            >
              <div style={{ width: '100%', position: 'absolute', top: `${100}%`, height: 'auto', border: 0 }}></div>
            </ReactQuill>
            {/* <span>{ReactHtmlParser(topicsStore.topic.description)}</span> */}
          </div>
        </div>
      </div>
    );
  }
}

export default BaseInformation;


// WEBPACK FOOTER //
// ./src/modules/topic/components/BaseInformation.js